import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Attendance from './Attendance';
import LeaveRequests from './LeaveRequests';
import Payroll from './Payroll';
import PayrollDetailsPage from './PayrollDetailsPage';
import Tasks from './Tasks';
import TaskDetailsPage from './TaskDetailsPage';

export const EmployeeRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/employee/attendance" replace />} />
      
      {/* Attendance Routes */}
      <Route path="/attendance" element={<Attendance />} />
      
      {/* Leave Requests Routes */}
      <Route path="/leave-requests" element={<LeaveRequests />} />
      
      {/* Payroll Routes */}
      <Route path="/payroll" element={<Payroll />} />
      <Route path="/payroll/:id" element={<PayrollDetailsPage />} />
      
      {/* Tasks Routes */}
      <Route path="/tasks" element={<Tasks />} />
      <Route path="/tasks/:id" element={<TaskDetailsPage />} />
      
      <Route path="*" element={<Navigate to="/employee/attendance" replace />} />
    </Routes>
  );
}; 